import React from 'react';

import { OutlinedIconButton } from 'components/DataEntry/Button/OutlinedIconButton';
import { DocumentsIcon } from 'components/Icons';

interface Props {
  onOpen: () => void;
  label: string;
}

export const LearnMoreButton = (props: Props) => {
  const { onOpen, label } = props;
  return (
    <OutlinedIconButton
      color="primary"
      leftIcon={<DocumentsIcon color="primary" />}
      onClick={() => onOpen()}
    >
      Learn about {label}
    </OutlinedIconButton>
  );
};
